import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import {
  AllMaterialTested,
  AllTestMethod,
  AllComponent,
} from "../../../../../../../features/admin/common/Slice";
import Select from "react-select";

import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  GetSingle,
  Update,
  GetAll,
} from "../../../../../../../features/admin/quality_management/structural_requirement/management_data/Slice";

import { formatDateForInput } from "../../../../../../../utils/common";

function SOP_Edit_Offcanvas({ show, handleClose, id, fetchCustomers }) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(AllMaterialTested());
    dispatch(AllComponent());
    dispatch(AllTestMethod());
  }, [dispatch]);

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      setLoading(true);
      const res = await dispatch(GetSingle(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.data;

        reset({
          name: data.name || "",
          remark: data.remark || "",
          documents:
            data?.Management_Data_Documents?.map((doc) => doc.document_path) ||
            [],
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && id) {
      GetData(id);
    }
  }, [show, id]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {
    const documents = getValues("documents") || [];

    if (documents.length === 0) {
      setShowError({ documents: "At least one document is required" });
      return;
    }

    try {
      const sendData = new FormData();

      sendData.append("name", data.name);
      sendData.append("management_data_id", 1);
      sendData.append("remark", data.remark);

      // handle existing vs new file
      if (data.documents) {
        const files = Array.isArray(data.documents)
          ? data.documents
          : Array.from(data.documents);

        files.forEach((file) => {
          if (file instanceof File) {
            sendData.append("documents", file); // only new files
          }
        });
      }

      if (removedFiles.length > 0) {
        sendData.append("removed_files", JSON.stringify(removedFiles));
      }

      const res = await dispatch(Update({ id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
        // dispatch(GetAll());
        await fetchCustomers();
        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      } else {
        setShowError(res.payload?.response?.data?.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleRemoveCompanies = () => {
    setCompaniesPreview(null);
    setValue("documents", null);
    setRemovedFiles((prev) =>
      prev.includes("documents") ? prev : [...prev, "documents"],
    );
  };

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit SOP
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    {...register("name", {
                      required: "SOP name is required",
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Remark</Form.Label>
                  <Form.Control
                    {...register("remark", {
                      required: "SOP remark is required",
                    })}
                  />
                  {errors.remark && (
                    <span className="text-danger">{errors.remark.message}</span>
                  )}
                </Form.Group>
              </div>

              {/* Documents*/}
              <div className="col-md-7">
                <Form.Group className="form_group file_field">
                  <Form.Label>Document</Form.Label>
                  <Form.Control
                    type="file"
                    multiple
                    onChange={(e) => {
                      const newFiles = e.target.files;

                      if (newFiles && newFiles.length > 0) {
                        const existing = getValues("documents") || [];

                        const updated = [...existing, ...Array.from(newFiles)];

                        setValue("documents", updated, {
                          shouldValidate: true,
                        });
                      }

                      e.target.value = null;
                    }}
                  />
                  {showError?.documents && (
                    <span className="text-danger">{showError.documents}</span>
                  )}

                  {(() => {
                    const fileValue =
                      watch("documents") ?? getValues("documents");

                    let files = [];

                    if (Array.isArray(fileValue)) {
                      files = fileValue.map((file) => {
                        if (typeof file === "string") {
                          return {
                            url: process.env.REACT_APP_IMG_URL + file,
                            type: file.toLowerCase(),
                            isExisting: true,
                            original: file,
                          };
                        } else {
                          return {
                            url: URL.createObjectURL(file),
                            type: file.type,
                            isExisting: false,
                            original: file,
                          };
                        }
                      });
                    }

                    // New uploaded files
                    else if (fileValue && fileValue.length > 0) {
                      files = Array.from(fileValue).map((file) => ({
                        url: URL.createObjectURL(file),
                        type: file.type,
                        isExisting: false,
                        original: file,
                      }));
                    }

                    if (!files.length) return null;

                    return (
                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {files.map((file, index) => (
                          <div
                            key={index}
                            className="image_holder position-relative"
                          >
                            {/* IMAGE */}
                            {(file.type.includes("image") ||
                              file.type.endsWith(".jpg") ||
                              file.type.endsWith(".png")) && (
                              <img src={file.url} className="img_preview" />
                            )}

                            {/* PDF */}
                            {(file.type.includes("pdf") ||
                              file.type.endsWith(".pdf")) && (
                              <iframe
                                src={file.url}
                                className="img_preview"
                                style={{ width: "100px" }}
                                title="PDF"
                              />
                            )}

                            {/* OTHER */}
                            {!file.type.includes("image") &&
                              !file.type.includes("pdf") && (
                                <a href={file.url} target="_blank">
                                  Open File
                                </a>
                              )}

                            {/* DELETE BUTTON */}
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              className="delete_icon"
                              onClick={() => {
                                const current = getValues("documents") || [];

                                const fileToRemove = current[index];

                                // track only existing files
                                if (typeof fileToRemove === "string") {
                                  setRemovedFiles((prev) => [
                                    ...prev,
                                    fileToRemove,
                                  ]);
                                }

                                // remove only that item
                                const updated = current.filter(
                                  (_, i) => i !== index,
                                );

                                setValue("documents", updated);
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    );
                  })()}
                </Form.Group>
              </div>
            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default SOP_Edit_Offcanvas;
